// store/favoritesSlice.js
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    items: JSON.parse(localStorage.getItem('favorites')) || [],
};

const favoritesSlice = createSlice({
    name: 'favorites',
    initialState,
    reducers: {
        addToFavorites: (state, action) => {
            const exists = state.items.find(item => item.ProductID === action.payload.ProductID);
            if (!exists) {
                state.items.push(action.payload);
            }
        },
        removeFromFavorites: (state, action) => {
            state.items = state.items.filter(item => item.ProductID !== action.payload.ProductID);
        },
    },
});

// Function to persist favorites to localStorage
const persistFavorites = (state) => {
    localStorage.setItem('favorites', JSON.stringify(state.items));
};

// Custom reducer function that calls persistFavorites
const favoritesReducer = (state, action) => {
    const newState = favoritesSlice.reducer(state, action);
    persistFavorites(newState);
    return newState;
};

export const { addToFavorites, removeFromFavorites } = favoritesSlice.actions;
export default favoritesReducer;
